/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Plan_Build_Organize_FullInputs */

const en_us2_plan_build_organize_full = /** @type {(inputs: Plan_Build_Organize_FullInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The plan already has the maximum of ${i?.max} workouts.`)
};

const pt_br2_plan_build_organize_full = /** @type {(inputs: Plan_Build_Organize_FullInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`O plano já tem o máximo de ${i?.max} treinos.`)
};

const es_419_plan_build_organize_full = /** @type {(inputs: Plan_Build_Organize_FullInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`El plan ya tiene el máximo de ${i?.max} entrenamientos.`)
};

const pt_pt2_plan_build_organize_full = /** @type {(inputs: Plan_Build_Organize_FullInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`O plano já tem o máximo de ${i?.max} treinos.`)
};

const fr_fr2_plan_build_organize_full = /** @type {(inputs: Plan_Build_Organize_FullInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Le programme a déjà le maximum de ${i?.max} séances.`)
};

const de_de2_plan_build_organize_full = /** @type {(inputs: Plan_Build_Organize_FullInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Der Plan hat schon das Maximum von ${i?.max} Trainings.`)
};

const it_it2_plan_build_organize_full = /** @type {(inputs: Plan_Build_Organize_FullInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`La scheda ha già il massimo di ${i?.max} allenamenti.`)
};

/**
* | output |
* | --- |
* | "The plan already has the maximum of {max} workouts." |
*
* @param {Plan_Build_Organize_FullInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_organize_full = /** @type {((inputs: Plan_Build_Organize_FullInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Organize_FullInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_organize_full(inputs)
	if (locale === "es-419") return es_419_plan_build_organize_full(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_organize_full(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_organize_full(inputs)
	if (locale === "de-DE") return de_de2_plan_build_organize_full(inputs)
	if (locale === "it-IT") return it_it2_plan_build_organize_full(inputs)
	return en_us2_plan_build_organize_full(inputs)
});
export { plan_build_organize_full as "plan-build.organize_full" }